import { api } from './api';

export interface EmailTemplate {
  id: string;
  name: string;
  category: string;
  subject: string;
  body?: string;
  isPublished: boolean;
  usageCount: number;
  lastUsedAt: string | null;
  userId?: string | null;
  createdAt: string;
  updatedAt?: string;
}

export async function fetchTemplates(): Promise<EmailTemplate[]> {
  const res = await api.get('/inbox/templates');
  return res.data.templates;
}

export async function fetchTemplate(templateId: string): Promise<EmailTemplate> {
  const res = await api.get(`/inbox/templates/${templateId}`);
  return res.data;
}

export async function createTemplate(input: {
  name: string;
  category?: string;
  subject: string;
  body: string;
}): Promise<EmailTemplate> {
  const res = await api.post('/inbox/templates', input);
  return res.data;
}

export async function updateTemplate(
  templateId: string,
  input: Partial<{ name: string; category: string; subject: string; body: string }>,
): Promise<EmailTemplate> {
  const res = await api.patch(`/inbox/templates/${templateId}`, input);
  return res.data;
}

export async function deleteTemplate(templateId: string): Promise<void> {
  await api.delete(`/inbox/templates/${templateId}`);
}

export async function useTemplate(templateId: string): Promise<EmailTemplate> {
  const res = await api.post(`/inbox/templates/${templateId}/use`, {});
  return res.data;
}
